import React, { useContext } from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalFooter } from '@coreui/react'
import { AppContext } from 'src/views/context/app'
import ClipboardCopy from 'src/components/copyToClipboard'
import CopyClipboardTextArea from 'src/components/copyToClipboardTextArea'

const ContentShareModal = ({ detail, onClose }) => {
  const { accountObj } = useContext(AppContext)

  const EmbededURL = accountObj.domain_name + '/embed/' + detail._id

  const getBaseLink = (contentType) => {
    let routeObj = {
      PLAYLIST: '/playlist/',
      MPVP: '/parent-content/',
    }

    if (routeObj[contentType]) {
      return routeObj[contentType]
    }

    return '/content/'
  }

  const Link = accountObj.domain_name + getBaseLink(detail?.video_type) + detail._id

  const embeddedLink = `<iframe 
  width = "100%"
  height = "315"
  style="background-color:#000"
  id = "myIframe_998785" 
  src = "${EmbededURL}" 
  frameborder = "0" 
  allowfullscreen 
  allow="encrypted-media"> 
  </iframe>
  <script> var viewPortTag=document.createElement('meta');viewPortTag.name='viewport';viewPortTag.content='width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=0;';window.parent.document.getElementsByTagName('head')[0].appendChild(viewPortTag);
  </script>`
  return (
    <CModal scrollable size="lg" visible={true} alignment="center" className="">
      <CModalHeader style={{}} className="d-flex flex-column align-items-start mt-1 px-5">
        <div className="d-flex justify-content-center w-100">
          <p style={{ fontSize: '1.2rem' }} className="">
            <b style={{ fontWeight: '500', color: '#191818' }}>Share Content</b>
          </p>
        </div>
      </CModalHeader>
      <CModalBody>
        <h6
          style={{ fontSize: '15px', color: '#191919' }}
          className={`${detail?.video_type === 'IPTV' ? 'd-flex justify-center' : ''}`}
        >
          {detail?.video_type !== 'IPTV' ? 'Perma Link' : 'Content sharing is not allowed in IPTV!'}
        </h6>
        {detail?.video_type !== 'IPTV' ? <ClipboardCopy copyText={Link} /> : null}

        {detail?.video_type === 'MPVP' ||
        detail?.video_type === 'LIVE' ||
        detail?.video_type === 'PLAYLIST' ||
        detail?.video_type === 'IPTV' ? (
          <></>
        ) : (
          <>
            <h6 style={{ fontSize: '15px', color: '#191919' }} className="mt-3">
              Embed Video Code
            </h6>
            <CopyClipboardTextArea copyText={embeddedLink} rows={16} />
          </>
        )}
      </CModalBody>
      <CModalFooter>
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={onClose}
        >
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ContentShareModal
